<section >

    <div class="container-fluid px-5 ">
        <div class="col-12 d-flex justify-content-between ">
            <div>
              <h2 class="text-left text-white mt-5">Crear riesgo</h2>

            </div>
            <br>
            <div class="d-flex justify-content-center align-items-center">
              <button
                class="badge rounded-pill btn btn-outline-light mt-5"
                [routerLink]="['/pdg/project/list/view/', idProject]"
              >
                <i
                  class="fa-solid fa-right-from-bracket m-2 fs-6"
                  aria-hidden="true"
                ></i>
                <span class="m-2 fs-6">Volver</span>
              </button>
        
             
        
          
        
            </div>
          </div>
        <br>
        <div class="backgroundTable card">
            <div class="card-header">
                <h4 class="text-white p-2 my-3">Crear riesgo proyecto: {{summaryInfoDto.title}}</h4>
            </div>
            <div class="componente-importantes componente-importantes-from-popup">
                <form action=""
                method="post"
                (submit)="formSubmit()"
                [formGroup]="createRiskForm">
                <div class="col">
                    <div class="form-group px-3 pb-3">
                        <label for="stagesIdRisk" class="text-white d-flex justify-content-start mb-2">Etapa</label>
                        <select required class="form-control custom-outline-input" formControlName="project_stages_id" id="project_stages_id">
                            <option Selected value="">Seleccione una etapa</option>
                            <option *ngFor="let item of listStage"[value]="item.id">{{item.name}}</option>
                        </select>
                    </div>
                    <div class="form-group px-3 pb-3">
                        <label for="nameRisk" class="text-white d-flex justify-content-start mb-2">Nombre</label>
                        <input type="text" required class="form-control custom-outline-input" id="name" name="name" placeholder="Nombre riesgo" formControlName="name">
                    </div>
                    <div class="form-group px-3 pb-3">
                        <label for="descriptionRisk" class="text-white d-flex justify-content-start mb-2">Descripcion</label>
                        <input type="text" required class="form-control custom-outline-input" id="description" name="description" placeholder="Descripcion" formControlName="description">
                    </div>
                    <div class="form-group px-3 pb-3">
                        <label for="activationDate" class="text-white d-flex justify-content-start mb-2">Fecha Activacion</label>
                        <input type="date" required class="form-control custom-outline-input date" id="activation_date" name="activation_date" placeholder="Fecha" formControlName="activation_date">
                    </div>
                    <div class="form-group px-3 pb-3">
                        <label for="deadlineDate" class="text-white d-flex justify-content-start mb-2">Fecha de deadline</label>
                        <input type="date" required class="form-control custom-outline-input date" id="deadline_date" name="deadline_date" placeholder="Fecha" formControlName="deadline_date">
                    </div>
                    <div class="form-group px-3 pb-3">
                        <label for="probability" class="text-white d-flex justify-content-start mb-2">Probabilidad</label>
                        <select required class="form-control custom-outline-input" formControlName="probability" id="probability">
                            <option selected value="">Seleccione una probabilidad</option>
                            <option  *ngFor="let item of listProbability" [value]="item.id">{{item.name}}</option>
                        </select>
                    </div>
                    <div class="form-group px-3 pb-3">
                        <label for="impact" class="text-white d-flex justify-content-start mb-2">Impacto</label>
                        <select required class="form-control custom-outline-input" formControlName="impact" id="impact">
                            <option Selected value="">Seleccione un impacto</option>
                            <option *ngFor="let item of listImpact" [value]="item.id">{{ item.name }}</option>
                        </select>
                    </div>
                    <div class="form-group px-3 pb-3">
                        <label for="impactRisk" class="text-white d-flex justify-content-start mb-2">Descripción Impacto</label>
                        <input type="text" required class="form-control custom-outline-input" id="impact_description" name="impact_description" placeholder="Descripción impacto" formControlName="impact_description">
                    </div>
                    <div class="form-group px-3 pb-3">
                        <label for="person" class="text-white d-flex justify-content-start mb-2">Responsable</label>
                        <select required class="form-control custom-outline-input" formControlName="users_id" id="users_id">
                            <option Selected value="">Seleccione un responsable</option>
                            <option *ngFor="let item of listPerson" [value]="item.users_id">{{item.username}}</option>
                        </select>
                    </div>
                    <div class="form-group d-flex justify-content-sm-end pt-3 py-4">
                        <button type="submit" class="btn btn-outline-light me-3"><i _ngcontent-xfk-c127="" class="fa-solid fa-floppy-disk m-1"></i>Guardar Riesgo</button>
                    </div>
                </div>

                </form>
            </div>
        </div>
    </div>

</section>